import Actions                                  from 'Redux/Actions';
import { Epic, ofType }                         from 'redux-observable';
import { EMPTY, from, of }                      from 'rxjs';
import { catchError, mergeMap, withLatestFrom } from 'rxjs/operators';
import { UserRepository }                       from 'Domain/Repositories';

export const checkSessionRequestEpic: Epic = (action$, store$) => {
  return action$.pipe(
    ofType(Actions.applicationBootstrapped.type),
    withLatestFrom(store$),
    mergeMap(([ action, store ]) => {
      const now = new Date();
      const { accessToken, accessTokenExpiresAt, refreshToken, refreshTokenExpiresAt } = store.authentication;
      const accessTokenExpiresAtDate = accessTokenExpiresAt ? new Date(accessTokenExpiresAt) : null;
      const refreshTokenExpiresAtDate = refreshTokenExpiresAt ? new Date(refreshTokenExpiresAt) : null;

      if (accessTokenExpiresAtDate && accessTokenExpiresAtDate > now) {
        UserRepository.setAuthorisationHeader(accessToken);
        return from(UserRepository.checkAuthorization()).pipe(
          mergeMap(refreshData => of(Actions.authenticationSuccess({ ...refreshData }))),
          catchError(error => {
            return from(UserRepository.refreshAccessToken(refreshToken)).pipe(
              mergeMap(refreshData => of(Actions.authenticationSuccess({ ...refreshData }))),
              catchError(error => from([
                Actions.authenticationFailure(error),
                Actions.logout()
              ])),
            );

          }),
        );
      }
      if (accessTokenExpiresAtDate && accessTokenExpiresAtDate < now && refreshTokenExpiresAtDate && refreshTokenExpiresAtDate > now) {
        return from(UserRepository.refreshAccessToken(refreshToken)).pipe(
          mergeMap(refreshData => of(Actions.authenticationSuccess({ ...refreshData }))),
          catchError(error => from([
            Actions.authenticationFailure(error),
            Actions.logout()
          ])),
        );
      }

      if (accessTokenExpiresAtDate && accessTokenExpiresAtDate < now && refreshTokenExpiresAtDate && refreshTokenExpiresAtDate < now) {
        return from([
          Actions.authenticationFailure({ error: new Error('No Authorization') }),
          Actions.logout()
        ]);
      }

      return EMPTY;

    }),
  );
};
